var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{staticClass:"link",style:(_vm.cssItemWidth),attrs:{"to":_vm.route}},[_c('div',{staticClass:"tab"},[_vm._v(" "+_vm._s(_vm.text)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }